module.exports = __webpack_public_path__ + "static/media/_litecoin-cash.9d817e96.svg";